<script lang="ts">
	import classnames from 'classnames';

	export let title: string | null = null;
</script>

<div class="course-certificates">
	<div class="certificates-card">
		<div class="certificates-title">
			{#if title}
				<p class="caption-title">{title}</p>
			{/if}
		</div>

		<div
			class={classnames(
				'certificates-list',
				$$props.class
					? $$props.class
					: 'grid-cols-none grid-flow-col md:grid-cols-2 md:grid-flow-row'
			)}
		>
			<slot />
		</div>
	</div>

	<div class="certificates-footer">
		<slot name="footer" />
	</div>
</div>

<style type="text/scss" lang="scss" scoped>
	.course-certificates {
	}

	.certificates-card {
		@apply rounded shadow-md;
		@apply bg-white;
		@apply p-6;
	}

	.certificates-title {
		@apply text-center;
	}

	.certificates-list {
		@apply grid;
		@apply gap-6;
		@apply py-4;
	}

	.certificates-footer {
		@apply mt-4;
		@apply text-gray-900;
		@apply md:text-center;
	}
</style>
